import { PageContainer, useIfUser } from '@if/mui'
import { useMerchant } from '@src/containers/App/MerchantProvider'
import {
  useCustomBuydownPlansQuery,
  useCustomBuydownSwitchStatusQuery,
} from '@src/data/api/custom-buydown-api/custom-buydown-api'
import { useBorrowerContext } from '@src/hooks/borrower-context-hooks'
import { useTranslation } from 'react-i18next'
import { CustomBuydownForm } from './components/CustomBuydownForm'
import { CustomBuydownSkeleton } from './components/CustomBuydownSkeleton'

const useCustomBuydownResources = () => {
  const user = useIfUser()
  return {
    plans: useCustomBuydownPlansQuery(user.merchantId),
    switchStatus: useCustomBuydownSwitchStatusQuery(user.merchantId),
  }
}

const CustomBuydownPage = () => {
  const { t } = useTranslation()
  const merchant = useMerchant()
  const context = useBorrowerContext()
  return (
    <PageContainer
      usePrimary={useCustomBuydownResources}
      title={t('customBuydown.title', { context })}
      subtitle={t('customBuydown.subtitle', { context })}
      loadingContent={<CustomBuydownSkeleton />}
    >
      {(data) => (
        <CustomBuydownForm
          activePlan={data.plans[0] ?? null}
          merchantId={merchant.id}
          switchStatus={data.switchStatus}
        />
      )}
    </PageContainer>
  )
}

export default CustomBuydownPage
